module.exports = __webpack_public_path__ + "img/menu-by-id.12f2ac59.jpg";